import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Event } from '../models/event';
import { Statistic } from '../models/statistic';

@Injectable({
    providedIn: 'root',
})
export class StatisticService {
    constructor(private http: HttpClient) {}

    createStatistic(data: Statistic): Observable<Statistic> {
        return this.http.post<Statistic>(`${environment.appApi}/statistic/create`, data);
    }
}
